import PrimaryButtonGradient from "@/app/component/gradientbutton";

import { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { useClientConfigProvider } from "@/app/config/client-config-provider";

import { InputTextBox } from "../InputTextBox";
import { useFormik } from "formik";
import * as Yup from "yup";
import ErrorMessage from "../error-message";
import { useAppContext } from "@thriwe-2-0/thriwe-ui-utils";
import ToastUtils from "@/app/toast/toast-utils";
import StringConstants from "@/app/constants/string-contants";
import Image from "next/image";
import { Trans, useTranslation } from "react-i18next";

function AddMembershipPopupDialog({
  show = true,
  showFromRegister = false,
  closeModal,
  passData,
  passMembershipId,
}: {
  show: boolean;
  showFromRegister?: boolean;
  closeModal: any;
  passData?: any;
  passMembershipId?: string;
}) {
  const context = useAppContext();
  const { t } = useTranslation();

  const {
    instances: { apiRepository },
    state: { memberships },
  } = context;
  const [showBenefitPackModal, setShowBenefitPackModal] =
    useState<boolean>(false);
  const [benefitGroupData, setBenefitGroupData] = useState<any>();
  const handleFormSubmit = (values: any) => {
    addUserMembershipApi(values?.membershipID ?? "");
  };
  // path
  const { getImagePath, StringConstantsInstance } = useClientConfigProvider();
  const [membershipLinked, setMembershipLinked] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectBenefitPack, setSelectBenefitPack] = useState<string>("");
  useEffect(() => {
    if (passData) {
      setBenefitGroupData(passData);
      setShowBenefitPackModal(true);
    }
  }, passData);
  const manageBenefitPack = (data: any) => {
    setShowBenefitPackModal(true);
    data.benefit_group = data.benefit_group.map((group: any) => {
      const matchedConfigs = data.benefit_group_configs.filter(
        (config: any) => config.benefit_group_id === group.id
      );

      return {
        ...group,
        benefit_group_configs_matched: matchedConfigs,
      };
    });
    setBenefitGroupData(data.benefit_group);
  };

  const addUserMembershipApi = (membershipID: string) => {
    setIsLoading(true);

    apiRepository
      ?.addMembership(membershipID)
      .then((v: any) => {
        if (v?.data && v?.data?.benefit_group?.length) {
          // closeModal();
          setShowBenefitPackModal(true);
          manageBenefitPack(v?.data);
          // setShowBenefitPackModal(true)
        } else {
          setMembershipLinked(true);
          setTimeout(() => {
            if (closeModal != null) closeModal();
          }, 5000);
          memberships?.refetch();
          setIsLoading(false);
        }
      })
      .catch((e: any) => {
        setIsLoading(false);
        if (e?.response?.data?.message) {
          ToastUtils.showErrorToast(e?.response?.data?.message);
        } else {
          ToastUtils.showErrorToast(t("common.errorMessage"));
        }
      });
  };

  const validationSchema = Yup.object().shape({
    membershipID: Yup.string().required(
      t("linkMembership.enterMembershipPrompt")
    ),
  });

  const memebershipForm = useFormik({
    initialValues: {
      membershipID: "",
    },
    validationSchema: validationSchema,
    onSubmit: handleFormSubmit,
    enableReinitialize: true,
    validateOnBlur: false,
  });
  const {
    setFieldValue,
    values,
    handleBlur,
    handleChange,
    submitForm,
    touched,
    errors,
  } = memebershipForm;

  if (showBenefitPackModal) {
    return (
      <div
        className="modal-container"
        style={{ backgroundColor: "white", height: "100%", zIndex: "" }}
      >
        <div
          className={
            show ? `blur-background-hide-header  transparent-background` : ""
          }
        />
        <Modal
          isOpen={show}
          toggle={() => {
            // if (!isBookingCreating) {
            //   closeModal();
            // }
          }}
          zIndex={""}
          className="benefit-pack-modal"
          contentClassName="modal-size-membership-pack"
          centered
          size="md"
        >
          <ModalBody className="benefit-pack-modal-body">
            <div className="benefit-pack-header">
              <div className="benefit-pack-heading">
                {t("linkMembership.chooseBenefitPack")}
              </div>
              <div className="benefit-pack-subheading">
                {t("linkMembership.chooseBenefitPackDescription")}
              </div>
            </div>
            {benefitGroupData?.map((item: any, index: number) => {
              return (
                <div className="benefit-packs-container" key={index}>
                  <div
                    className="benefit-packs-header"
                    onClick={() => {
                      setSelectBenefitPack(item?.id);
                    }}
                    role="button"
                  >
                    <Image
                      className="c-pointer termscondition-checkbox"
                      id="terms&condition"
                      alt=""
                      src={getImagePath(
                        selectBenefitPack !== item?.id
                          ? "checkbox1.svg"
                          : "checked-checkbox1.svg"
                      )}
                      width={18}
                      height={18}
                    />
                    <div className="benefits-packs-heading">
                      {item?.display_name}
                    </div>
                  </div>

                  <div className="benefit-packs-multiple">
                    {item?.benefit_group_configs_matched?.map(
                      (benefits: any, index: number) => {
                        return (
                          <div className="benefit-single-container" key={index}>
                            <div className="benefit-single-detail">
                              <div className="benefit-partner-name">
                                {benefits?.name}
                              </div>
                              <div className="benefit-description">
                                {benefits?.benefit_offered}
                              </div>
                            </div>
                            <div
                              className="benefit-partner-image"
                              style={{ background: "grey", width: "40px" }}
                            >
                              <Image
                                src={
                                  benefits?.images?.logo == ""
                                    ? "/common-images/img_partner_placeholder.jpg"
                                    : benefits?.images?.logo
                                }
                                alt={""}
                                height={"40"}
                                width={"40"}
                              />
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              );
            })}
            <div className="benefit-pack-modal_footer_btn_container">
              {
                <button
                  disabled={!memberships?.data?.length ? true : false}
                  className={`custom_bordered_btn_container`}
                  onClick={(e) => {
                    // closeModal();
                    if (e.currentTarget.disabled) {
                      return;
                    }
                    setShowBenefitPackModal(false);
                    closeModal();
                    setIsLoading(false);
                  }}
                >
                  <span className="custom_bordered_btn_text">
                    {t("common.Cancel")}
                  </span>
                </button>
              }

              <button
                className="custom_filled_btn_container"
                onClick={() => {
                  console.log("passMembershipId 1", passMembershipId);
                  console.log("passMembershipId 2", values?.membershipID);
                  let membershipId: string | undefined = values.membershipID;
                  if (!membershipId) {
                    membershipId = passMembershipId;
                  }
                  if (!selectBenefitPack) {
                    ToastUtils.showErrorToast(
                      "",
                      t("linkMembership.selectBenefitPackPrompt")
                    );
                    return;
                  }
                  apiRepository
                    ?.addMembershipBenefitPack({
                      data: {
                        benefit_group_id: selectBenefitPack,
                        membership_id: membershipId,
                      },
                    })
                    .then((v) => {
                      setShowBenefitPackModal(false);

                      setMembershipLinked(true);
                      memberships?.refetch();
                      setTimeout(() => {
                        closeModal();
                      }, 3000);
                    })
                    .catch((errors) => {
                      ToastUtils.showErrorToast(
                        errors?.response?.data?.message
                      );
                    });
                }}
              >
                <span className="custom_filled_btn_text">
                  {t("common.Apply")}
                </span>
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  } else if (!memberships?.data?.length && showFromRegister) {
    return (
      <div className="membership-container" style={{}}>
        <div className="membership-container-layout2" style={{}}>
          <div className="membership-link-text-info2" style={{}}>
            <div className="membership-link-gif">
              <img
                src={getImagePath("link-logo.gif")}
                alt="Loading"
                style={{ width: "40%", height: "auto" }}
              />
            </div>
            <div className="membership-link-text-info-heading">
              <Trans
                i18nKey="linkMembership.title"
                components={{ br: <br /> }}
              />
            </div>

            <div className="membership-link-text-info-subheading">
              {t("linkMembership.description")}
            </div>
          </div>

          <div className="membership-link-form2" style={{}}>
            {membershipLinked ? (
              <>
                <div className="membership-link-gif2">
                  <img
                    src={getImagePath("success.gif")}
                    alt="Loading"
                    style={{
                      width: "100%",
                      maxWidth: "300px",
                      height: "auto",
                      display: "block",
                      margin: "auto",
                    }}
                  />
                  <div className="membership-link-text-info-heading">
                    {t("linkMembership.yourMembershipLinked")}
                  </div>
                </div>
              </>
            ) : (
              <>
                {
                  <div>
                    <div className="add-link-text-style">
                      {t("linkMembership.subTitle")}
                    </div>
                    <div className="my-2 add-link-text-style-subtext">
                      {t("linkMembership.enterMembershipId")}
                    </div>
                    <InputTextBox
                      hint={"Membership ID"}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="membershipID"
                      value={values.membershipID}
                      placeholder={t("linkMembership.membershipId")}
                      hasError={
                        touched?.membershipID != null &&
                        errors?.membershipID != null
                      }
                    />
                    <ErrorMessage
                      message={
                        touched?.membershipID
                          ? errors.membershipID ?? ""
                          : undefined
                      }
                      touched={touched?.membershipID}
                    />
                  </div>
                }

                <PrimaryButtonGradient
                  margin="20px 0px 10px 0px"
                  name={t("linkMembership.addMembership")}
                  fullWidth={true}
                  onClick={submitForm}
                  isLoading={isLoading}
                  classNameDiv="buttonDiv"
                  showArrow={true}
                  arrowIcon={<span></span>}
                  classNameBackgroundStylePrimaryGradient="buttonBackgroundStylePrimaryGradient2"
                  classNamePrimaryIsLoading="buttonBackgroundStylePrimaryGradient2"
                />
              </>
            )}
          </div>
        </div>
      </div>
    );
  } else if (show && memberships?.data?.length)
    return (
      <>
        {" "}
        <div
          className={
            show && !memberships?.data?.length
              ? `blur-background-hide-header  transparent-background`
              : ""
          }
        />
        <Modal
          zIndex={""}
          isOpen={!memberships?.data?.length ? false : show}
          toggle={closeModal}
          className="modal-size-membership"
          centered
          style={{ zIndex: 1000 }}
          size="lg"
        >
          <ModalBody className="modal1-dialog">
            <div className="membership-container" style={{}}>
              <div className="membership-container-layout2" style={{}}>
                <div className="membership-link-text-info2" style={{}}>
                  <div className="membership-link-gif">
                    <img
                      src={getImagePath("link-logo.gif")}
                      alt="Loading"
                      style={{ width: "40%", height: "auto" }}
                    />
                  </div>

                  <div className="membership-link-text-info-heading">
                    <Trans
                      i18nKey="linkMembership.title"
                      components={{ br: <br /> }}
                    />
                  </div>

                  <div className="membership-link-text-info-subheading">
                    {t("profile.savingsWithClientHeading")}
                  </div>
                </div>

                <div className="membership-link-form2" style={{}}>
                  {membershipLinked ? (
                    <>
                      <div className="membership-link-gif2">
                        <img
                          src={getImagePath("success.gif")}
                          alt="Loading"
                          style={{
                            width: "100%",
                            maxWidth: "300px",
                            height: "auto",
                            display: "block",
                            margin: "auto",
                          }}
                        />
                        <div className="membership-link-text-info-heading">
                          {t("linkMembership.yourMembershipLinked")}
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      {
                        <div>
                          <div className="add-link-text-style">
                            {t("linkMembership.subTitle")}
                          </div>
                          <div className="my-2 add-link-text-style-subtext">
                            {t("linkMembership.enterMembershipId")}
                          </div>
                          <InputTextBox
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="membershipID"
                            value={values.membershipID}
                            placeholder={t("linkMembership.membershipId")}
                            hasError={
                              touched?.membershipID != null &&
                              errors?.membershipID != null
                            }
                          />
                          <ErrorMessage
                            message={
                              touched?.membershipID
                                ? errors.membershipID ?? ""
                                : undefined
                            }
                            touched={touched?.membershipID}
                          />
                        </div>
                      }

                      <PrimaryButtonGradient
                        margin="20px 0px 10px 0px"
                        name={t("linkMembership.addMembership")}
                        fullWidth={true}
                        onClick={submitForm}
                        isLoading={isLoading}
                        classNameDiv="buttonDiv"
                        showArrow={true}
                        arrowIcon={<span></span>}
                        classNameBackgroundStylePrimaryGradient="buttonBackgroundStylePrimaryGradient2"
                        classNamePrimaryIsLoading="buttonBackgroundStylePrimaryGradient2"
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </>
    );
}
export default AddMembershipPopupDialog;
